export default __webpack_public_path__ + "static/media/img-47.8dbf5896.jpg";